import { useCallback, useState, type ReactElement } from 'react'
import { DEFAULT_PROGRAM_DURATIONS, PROGRAM_DURATION_OPTIONS } from '@front/model'
import { Group, NumberInput, Select } from '@mantine/core'
import { type WithProgramForm } from './type'

export const ProgramDuration = ({ form }: WithProgramForm): ReactElement => {
  const [isCustom, setIsCustom] = useState(!DEFAULT_PROGRAM_DURATIONS.includes(form.values.totalDays ?? 1))

  const handleSelect = useCallback(
    (value: string | null): void => {
      if (!value) return
      if (value === 'custom') {
        setIsCustom(true)
        form.setFieldValue('totalDays', 1)
        return
      }
      setIsCustom(false)
      form.setFieldValue('totalDays', Number(value))
    },
    [form, setIsCustom]
  )

  return (
    <Group>
      <Select
        data={PROGRAM_DURATION_OPTIONS}
        flex={1}
        label='Duration'
        value={isCustom ? 'custom' : form.values.totalDays?.toString()}
        onChange={handleSelect}
      />
      {isCustom && (
        <NumberInput allowDecimal={false} flex={1} label='Days' min={1} {...form.getInputProps('totalDays')} />
      )}
    </Group>
  )
}
